(function () {
  const panelSelector = '[data-collection-acknowledgement]';
  const checkoutSelector = 'button[name="checkout"]';
  const disabledClass = 'arb-collection-checkout-disabled';

  function getCheckoutButton(panel) {
    const formId = panel.querySelector('[form]')?.getAttribute('form');
    if (formId) {
      return document.querySelector(`${checkoutSelector}[form="${formId}"]`);
    }

    return panel.closest('form')?.querySelector(checkoutSelector);
  }

  function getDynamicCheckoutContainer(button) {
    return button
      ?.closest('.cart__blocks, .drawer__footer')
      ?.querySelector('.cart__dynamic-checkout-buttons, #dynamic-checkout-cart');
  }

  function updatePanel(panel) {
    const button = getCheckoutButton(panel);
    if (!button) return;

    const checkbox = panel.querySelector('[data-collection-ack-checkbox]');
    const collectionPreferenceInputs = panel.querySelectorAll('[data-collection-preference]');
    const collectionPreference = panel.querySelector('[data-collection-preference]:checked');
    const isEmptyCart = Boolean(button.closest('.is-empty'));
    const needsCollectionPreference = collectionPreferenceInputs.length > 0;
    const canCheckout =
      !isEmptyCart && Boolean(checkbox?.checked) && (!needsCollectionPreference || Boolean(collectionPreference));
    const dynamicCheckout = getDynamicCheckoutContainer(button);

    button.disabled = !canCheckout;
    button.setAttribute('aria-disabled', String(!canCheckout));

    if (dynamicCheckout) {
      dynamicCheckout.classList.toggle(disabledClass, !canCheckout);
      dynamicCheckout.setAttribute('aria-disabled', String(!canCheckout));
    }
  }

  function updateAllPanels() {
    document.querySelectorAll(panelSelector).forEach(updatePanel);
  }

  document.addEventListener('change', (event) => {
    if (event.target.closest(panelSelector)) {
      updatePanel(event.target.closest(panelSelector));
    }
  });

  document.addEventListener('DOMContentLoaded', updateAllPanels);

  new MutationObserver(updateAllPanels).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
